// extracted by mini-css-extract-plugin
export var aboveInput = "_nz-0";
export var actionButton = "_nz-5";
export var actionButtonContainer = "_nz-1";
export var actionIcon = "_nz-6";
export var aiInfoContainer = "_nz-2";
export var attachmentWrapper = "_nz-7";
export var bold = "_nz-3";
export var checkIcon = "_nz-8";
export var clickingRecipientBar = "_nz-11";
export var commentThreadSwitch = "_nz-a";
export var draftImage = "_nz-b";
export var draftImageContainer = "_nz-c";
export var draftImages = "_nz-e";
export var editButton = "_nz-g";
export var editor = "_nz-f";
export var editorContainer = "_nz-y";
export var editorErrorTooltipWrapper = "_nz-9";
export var headerDivider = "_nz-h";
export var icon = "_nz-i";
export var info = "_nz-j";
export var internal = "_nz-n";
export var internalDivider = "_nz-k";
export var internalMessage = "_nz-l";
export var messageInputCard = "_nz-m";
export var messageInputForm = "_nz-o";
export var messageInputFormInternal = "_nz-p";
export var options = "_nz-q";
export var publicMessageCustomer = "_nz-s";
export var publicMessageMerchant = "_nz-r";
export var removeImageButton = "_nz-d";
export var replyButtons = "_nz-t";
export var showSignatureButton = "_nz-u";
export var spinner = "_nz-v";
export var verticalButtonDivider = "_nz-4";
export var visibilitySelector = "_nz-w";
export var warning = "_nz-x";
export var wrappingText = "_nz-z";
export var writingInternalNoteTopBorder = "_nz-10";